import { ExtendedAddress } from '@porterin/booking-flow/src/order-review/domain/entities/ExtendedAddress';
import Button from '@porterin/component-library/src/base-components/button/Button';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import { MapAutoDetectLocationCmpDesktop } from '@porterin/component-library/src/location-accuracy/components/MapAutoDetectLocationCmpDesktop';
import { GaEventsLocationAccuracy } from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import { publishEvent } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import { LatLng } from '@porterin/lead-flow/src/domain/entities/Address';
import React from 'react';

export interface MapLocationAddressProps {
  is_dragging: boolean;
  set_center: (value: React.SetStateAction<LatLng>) => void;
  handleZoomIn?: () => void;
  handleZoomOut?: () => void;
}

export const MapLocationAddressCmpDesktop: React.FC<
  MapLocationAddressProps
> = ({ is_dragging, set_center, handleZoomIn, handleZoomOut }) => {
  const { state, confirmLocation } = useLocation();

  const onConfirm = () => {
    publishEvent({
      category: 'Location Accuracy',
      action:
        state.waypoint === 'Pickup'
          ? GaEventsLocationAccuracy.confirmPickup
          : GaEventsLocationAccuracy.confirmDrop,
    });
    confirmLocation(state.address as ExtendedAddress);
  };

  if (is_dragging) {
    return null;
  }

  return (
    <div
      data-testid="map-overlay"
      id="map-overlay"
      className="w-full z-10 bg-white transform animate-slide-in"
    >
      <MapAutoDetectLocationCmpDesktop
        is_dragging={is_dragging}
        set_center={set_center}
        handleZoomIn={handleZoomIn}
        handleZoomOut={handleZoomOut}
      />
      <Button
        type="button"
        data-testid="submit-location-address"
        identifiers={{ id: 'submit-location-address' }}
        onClick={onConfirm}
        className="w-full p-4 bg-[#0a57ff] text-white
          font-semibold text-[1.4rem] leading-[2rem] active:bg-blue-700 disabled:bg-[#9499a3]"
      >
        Confirm {state.waypoint} Location
      </Button>
    </div>
  );
};
